<template>
  <b-modal
    ref="widgetsDataModal"
    hide-footer
    centered
    title="Widgets data"
    size="lg"
    >
    <b-form-group label="Path:" v-if="$can('all', 'Admin')">
      <b-form-input
        type="text"
        v-model.trim="path"
        @keydown.native.32.prevent
        />
    </b-form-group>
    <JsonEditor
      v-if="jsonData"
      :objData="jsonData"
      @onSave="dataChanged"
      />
  </b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

let $ = window.$

export default {
  props: ['widgetsData'],
  data () {
    return {
      childPath: [],
      path: '/'
    }
  },
  computed: {
    jsonData () {
      if (this.childPath.length) {
        let data = this.widgetsData
        for (let key of this.childPath) {
          if (!data[key]) {
            data = {}
            break
          }
          data = data[key]
        }
        return data
      } else {
        return this.widgetsData
      }
    }
  },
  watch: {
    path () {
      if (this.path.slice(0, 1) !== '/') this.path = '/' + this.path
      if (!this.path.length || this.path === '/') this.childPath = []
      else this.childPath = this.path.split('/').slice(1)
    }
  },
  methods: {
    dataChanged (newData) {
      let path = (this.childPath.length) ? this.childPath.join('/') : null
      db.widgets.updateDataByPath(path, newData, (err) => {
        if (err) {
          this.$store.commit('addError', err.message)
        } else {
          if (this.$refs.widgetsDataModal) this.$refs.widgetsDataModal.hide()
        }
      })
    }
  },
  created () {
    eventBus.$on('showWidgetsDataModal', () => {
      if (this.$refs.widgetsDataModal) this.$refs.widgetsDataModal.show()
    })

    eventBus.$on('widgetsDataModalCall', (path) => {
      $('.modal .close').trigger('click')
      this.$nextTick(() => {
        this.path = path
        if (this.$refs.widgetsDataModal) this.$refs.widgetsDataModal.show()
      })
    })
  },
  mounted () {
    if (this.$refs.widgetsDataModal) {
      $(this.$refs.widgetsDataModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.widgetsDataModal) {
      $(this.$refs.widgetsDataModal['$el']).remove()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/WidgetsData.vue